import { withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';

export const StaticPopupIconAutocomplete = withStyles({
  popupIndicatorOpen: { transform: 'none' }
})(Autocomplete);
